<template>
  <div class="xq">
    <div style="width: 100%">
      <img style="width: 100%;height: auto;max-height: 100%" src="../assets/img/xqimg1.png"/>
    </div>
    <div class="contain">
      <div style="width: 100%;height: auto;display: flex;">
        <div style="width: 50%;display: flex;justify-content: center;align-items: center;flex-direction: column">
          <div style="width: 60%">
            <div style="font-size: 43px;
            font-weight: bold;
            color: #353535;
            line-height: 39px;">
              红亚冠名班
            </div>
            <div style="font-size: 16px;
              font-weight: 400;
              color: #6A6A6A;
              line-height: 31px;margin-top: 3%">
              企业参与到专业人才培养方案和课程标准的制定中，为企业量身定制所需人才，使课程与企业需求紧密结合，让教学更具有前瞻性。利用企业丰富的教学资源，通过以赛促练的方式加强专业技能学习，全面提升学生的专业技能和综合素养。</div>
            <div style="width: 94px;height: 3px;background-color:#D8D8D8;margin-top: 65px">

            </div>
          </div>
        </div>
        <div style="width: 50%">
          <img style="width: 100%;height: 100%" src="../assets/img/xqimg9.png" alt="">
        </div>
      </div>


      <div style="width: 100%;height: auto;display: flex;">
        <div style="width: 50%">
          <img style="width: 100%;height: 100%" src="../assets/img/xqimg10.png" alt="">
        </div>
        <div style="width: 50%;display: flex;justify-content: center;align-items: center;flex-direction: column">
          <div style="width: 70%">
            <div style="font-size: 43px;
            font-weight: bold;
            color: #353535;
            line-height: 39px;">
              现代学徒制
            </div>
            <div style="font-size: 16px;
              font-weight: 400;
              color: #6A6A6A;
              line-height: 31px;margin-top: 3%">
              形成“现代学徒制”校企共同育人的长效机制，实现招生招工一体化，建立适于“现代学徒制”的人才培养制度，打造优秀的“双导师”团队，健全“现代学徒制”管理制度，建立高水平的实习实训基础。
            </div>
            <div style="width: 94px;height: 3px;background-color:#D8D8D8;margin-top: 65px">

            </div>
          </div>
        </div>

      </div>
      <div style="width: 100%;height: auto;display: flex;">
        <div style="width: 50%;display: flex;justify-content: center;align-items: center;flex-direction: column">
          <div style="width: 60%">
            <div style="font-size: 43px;
            font-weight: bold;
            color: #353535;
            line-height: 39px;">
              产业学院
            </div>
            <div style="font-size: 16px;
              font-weight: 400;
              color: #6A6A6A;
              line-height: 31px;margin-top: 3%">
              产业学院不断吸纳在校优秀学生，并对学生按照企业标准提出工作要求。对产业学院的学生采取从入企源头开始的竞争和筛选。 运用项目让学生快速自主学习和成长，查缺补漏，强化专业技能，自我拓展学习，拓宽学习边界，增加学习延展性。            </div>
            <div style="width: 94px;height: 3px;background-color:#D8D8D8;margin-top: 65px">

            </div>
          </div>
        </div>
        <div style="width: 50%">
          <img style="width: 100%;height: 100%" src="../assets/img/xqimg3.png" alt="">
        </div>
      </div>
      <div style="width: 100%;height: auto;display: flex;">
        <div style="width: 50%">
          <img style="width: 100%;height: auto" src="../assets/img/xqimg4.png" alt="">
        </div>
        <div style="width: 50%;display: flex;justify-content: center;align-items: center;flex-direction: column">
          <div class="box" style="width: 90%;display: flex;height: auto;justify-content: center">
            <div class="row" style="justify-content: center;align-items: center;display: flex;flex-direction: column">
              <img  class="xqhzimg" src="../assets/img/xqimg5.png">
              <img class="xqhzimg" src="../assets/img/xqimg6.png">
            </div>

            <div class="row" style="justify-content: center;align-items: center;display: flex;flex-direction: column">
              <img class="xqhzimg" src="../assets/img/xqimg7.png">
              <img class="xqhzimg" src="../assets/img/xqimg8.png">
            </div>
            <div >
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Xqhz1"
}
</script>

<style lang="scss" scoped>
img{
  width: auto;max-width: 100%;height: auto;max-height: 100%
}
.xq{
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  .contain{
    margin-top: 30px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .titlesxq{
      height: 150px;
      margin-top: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .titlesxq-con{
        height: 31px;
        font-size: 32px;

        font-weight: bold;
        color: #1F2D5D;
        line-height: 18px;
      }
      .titlesxq-seccon{
        width: 100%;
        height: 80px;
        font-size: 18px;

        font-weight: 400;
        color: #6A6A6A;
        line-height: 31px;
        text-align: center;
      }
    }
    .xdxtz{
      height: 233px;
      width: 100%;
      display: flex;
      margin-top: 40px;
      .xdxtzimg{
        width: 40%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .xdxtztitle{
        width: 60%;
        height: 100%;
        display: flex;
        padding-left: 50px;
        align-items: center;
        .xdxtztitle1{
          width: 100%;
          height: 28px;
          font-size: 29px;

          font-weight: bold;
          color: #353535;
          line-height: 26px;
        }
        .xdxtztitle2{
        height: 80px;
        font-size: 18px;

        font-weight: 400;
        color: #6A6A6A;
        line-height: 31px;
        }
      }
    }

  }
}

.xdxtztitle3{
  width: 60%;
  height: 100%;
  display: flex;
  padding-right: 50px;
  align-items: center;
  justify-content: flex-end;
  .xdxtztitle4{
  display: flex;
  flex-direction: column;
  align-items: flex-end;
    .xdxtztitle31{
      width: 100%;
      height: 28px;
      font-size: 29px;

      font-weight: bold;
      color: #353535;
      line-height: 26px;
      text-align: right;
    }
    .xdxtztitle2{
      height: 80px;
      font-size: 18px;

      font-weight: 400;
      color: #6A6A6A;
      line-height: 31px;
    }
  }
}

.pics{
  width: 100%;
  height: 300px;
  margin: 50px 0 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pics2{
  width: 100%;
  height: 300px;
  margin: 5px 0 40px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
//.box {
//  height: 100%;
//  display: flex;
//  flex-wrap: wrap;
//  align-content: space-between;
//}
//
//.row {
//  flex-basis: 100%;
//  display: flex;
//  justify-content: space-between;
//}
.xqhzimg{
  margin: 10px;
  width: 90%;
}
</style>
